import React, { useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import { DropzoneArea } from "mui-file-dropzone";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import isEmpty from "lodash-es/isEmpty";

const UploadFileDialog = ({
  uploadDialogOpen,
  setUploadDialogOpen,
  fileTypes,
  onChangeUploadFiles,
  helpMessage,
  downloadTemplateMessage,
  downloadTemplateUrl,
  filesLimit = 1,
  onClickDone,
}) => {
  useEffect(() => {}, []);

  const [_selectedFiles, setSelectedFiles] = React.useState([]);

  const handleChangeImportFiles = (files) => {
    if (onChangeUploadFiles) {
      onChangeUploadFiles(files);
    }
    setSelectedFiles(files);
  };

  const handleClickDone = () => {
    if (onClickDone) {
      onClickDone(_selectedFiles);
    }
  };

  return (
    <Dialog fullWidth={true} open={uploadDialogOpen}>
      <DialogTitle sx={{ p: 1 }}>Select Input File</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        {isEmpty(helpMessage) === false && (
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            {helpMessage}
          </Alert>
        )}

        {(isEmpty(downloadTemplateMessage) === false ||
          isEmpty(downloadTemplateUrl) === false) && (
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            {isEmpty(downloadTemplateMessage) === false && (
              <>{downloadTemplateMessage}</>
            )}
            <br />
            {isEmpty(downloadTemplateUrl) === false && (
              <>
                Download template <Link href={downloadTemplateUrl}>HERE</Link>.
              </>
            )}
          </Alert>
        )}

        <DropzoneArea
          filesLimit={filesLimit}
          onChange={(files) => handleChangeImportFiles(files)}
          acceptedFiles={fileTypes}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setUploadDialogOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            handleClickDone();
          }}
        >
          DONE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadFileDialog;
